import { assocPath } from 'ramda';

export const mapActionsWithReportingRoute = (actions, reportingRoute) =>
  actions.map(action => assocPath(['payload', 'reportingRoute'], reportingRoute, action));
